.appcues-preview-frame-message-container
    .appcues-preview-frame-message.container
        .row
            .col-md-12
                h2 Install the Appcues Chrome Extension
        .row
            .col-md-12
                p It looks like our normal preview frame wasn't working for you. This alternate method requires that you be using the Chrome/Chromium web browser and have installed the Appcues chrome extension.
                | Use #[a(href="#{link}", target="_blank") this link] to install the extension in your browser and then reload this page to get started!
